import { IMSALConfiguration } from 'ApplicationFrameRemote/Menu'

const location = window.location.origin

export function getAPIDomain(): string {
  const domain = process.env.API_DOMAIN //This only is defined when running with webpack serve
  if (domain) return domain

  //@ts-ignore
  return window.SCENARIOS_URL || ''
}
export function getAPI(): string {
  const domain = getAPIDomain()
  return `${domain}/api`
}

let msalConfig: IMSALConfiguration = {
  clientId: '',
  tenantId: '',
  scopes: [''],
  redirectUri: '',
}

let authorizationConfig: any = {
  apiscope: '',
}

export function updateConfig(config: any) {
  msalConfig = config.authentication
  authorizationConfig = config.authorization
  maintenanceConfig = config.maintenance
  environment = config.environment
}

export function getMSALConfiguration(): IMSALConfiguration {
  return msalConfig
}

export function getAuthorizationConfig(): any {
  return authorizationConfig
}

let maintenanceConfig = 'False'
export function getMaintenance(): string {
  return maintenanceConfig
}

let environment = 'production'
export function getEnvironment(): string {
  return environment
}
